export type GeneratedPageDataSource = "mock" | "remote";

export interface GeneratedPageDataConfig {
  dataKeys?: string[];
  mockData?: Record<string, any>;
  mockLoader?: () => Promise<Record<string, any>>;
  defaultSource?: GeneratedPageDataSource;
}

export function resolveGeneratedPageDataSource(
  config?: GeneratedPageDataConfig,
  mockSearchParam?: string | null,
): GeneratedPageDataSource {
  if (mockSearchParam === "1") {
    return "mock";
  }

  if (mockSearchParam === "0") {
    return "remote";
  }

  if (config?.defaultSource) {
    return config.defaultSource;
  }

  if (config?.dataKeys?.length) {
    return "remote";
  }

  return "mock";
}

export function getGeneratedPageDataConfigError(
  source: GeneratedPageDataSource,
  config?: GeneratedPageDataConfig,
): GeneratedPageDataSource | null {
  if (source === "remote" && !config?.dataKeys?.length) {
    return "remote";
  }

  if (source === "mock" && !config?.mockData && !config?.mockLoader) {
    return "mock";
  }

  return null;
}
